import { useMemo } from "react";
import type { DocumentWithTags } from "./documentTableTypes";

import type { documentTableOptions } from "./documentTableOptions";
import type { useTableSigning } from "./useTableSigning";
type Options = Pick<ReturnType<typeof documentTableOptions>, "onContainerClick"> &
  Pick<ReturnType<typeof useTableSigning>, "allDocuments">;
const CONTAINER_EXTENSIONS = [".zip", ".asice", ".bdoc", ".ddoc"];
const isContainerFile = (filename: string) =>
  CONTAINER_EXTENSIONS.some((ext) => filename.toLowerCase().endsWith(ext));

export function useTableDocumentKinds(options: Options) {
  const { onContainerClick, allDocuments } = options;
  // Separate container files from regular documents when container navigation is enabled.

  const { containerFiles, regularDocuments } = useMemo(() => {
    if (!onContainerClick) {
      return { containerFiles: [] as DocumentWithTags[], regularDocuments: allDocuments };
    }
    const containers: DocumentWithTags[] = [];
    const regular: DocumentWithTags[] = [];
    for (const doc of allDocuments) {
      if (isContainerFile(doc.filename)) {
        containers.push(doc);
      } else {
        regular.push(doc);
      }
    }
    return { containerFiles: containers, regularDocuments: regular };
  }, [allDocuments, onContainerClick]);

  const displayDocuments = regularDocuments;
  return { displayDocuments, containerFiles };
}
